import React from 'react';
import './CLFeature.scss';
import { featuresCL, featuresCLPC } from '../Contacts/constants';

export const desktopGridClasses = [
  'div1', // Eye image
  'div2', // UV Protection
  'div3', // Hyaluronic Acid
  'div4', // High Water Content
  'div5', // Side eye image
  'div6', // Ultra-Thin Design
  'div7', // Lens case image
  'div8', // Homegrown Excellence
  'div9', // Shape Retention
  'div10', // Anti Blue Light
];

export const CLFeature = () => {
  return (
    <div className="body-contacts__why-owndays-section">
      <div className="body-contacts__why-owndays-section__title">
        <h2>WHY OWNDAYS CONTACT LENS?</h2>
      </div>
      {/* Mobile Feature List */}
      <div className="body-contacts__why-owndays-section__features features-mobile">
        {featuresCL.map((feature, idx) => {
          const gridClass = `div${idx + 1}`;
          const isImageCard = !!feature.image && !feature.title && !feature.icon && !feature.desc;
          return (
            <div
              key={idx}
              className={`body-contacts__why-owndays-section__feature-card ${gridClass}${
                isImageCard ? ' feature-card--image' : ''
              }`}
            >
              {feature.icon && (
                <div className="body-contacts__why-owndays-section__feature-icon">
                  <img alt="" src={feature.icon} />
                </div>
              )}
              {feature.image && (
                <img
                  alt={feature.alt || ''}
                  className="body-contacts__why-owndays-section__feature-image"
                  src={feature.image}
                />
              )}
              {feature.title && (
                <div className="body-contacts__why-owndays-section__feature-title">
                  {feature.title}
                </div>
              )}
              {feature.desc && (
                <div className="body-contacts__why-owndays-section__feature-desc">
                  {feature.desc}
                </div>
              )}
            </div>
          );
        })}
      </div>
      {/* Desktop Feature List */}
      <div className="body-contacts__why-owndays-section__features features-desktop">
        {featuresCLPC.map((feature, idx) => {
          const gridClass = desktopGridClasses[idx];
          const isImageCard = !!feature.image && !feature.title && !feature.icon && !feature.desc;
          return (
            <div
              key={idx}
              className={`body-contacts__why-owndays-section__feature-card ${gridClass}${
                isImageCard ? ' feature-card--image' : ''
              }`}
            >
              {feature.icon && (
                <div className="body-contacts__why-owndays-section__feature-icon">
                  <img alt="" src={feature.icon} />
                </div>
              )}
              {feature.image && (
                <img
                  alt={feature.alt || ''}
                  className="body-contacts__why-owndays-section__feature-image"
                  src={feature.image}
                />
              )}
              <div className="body-contacts__why-owndays-section__feature-content">
                {feature.title && (
                  <div className="body-contacts__why-owndays-section__feature-title">
                    {feature.title}
                  </div>
                )}
                {feature.desc && (
                  <div className="body-contacts__why-owndays-section__feature-desc">
                    {feature.desc}
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
